import styled from "styled-components";

export interface IDotProps {
  color: string;
}

export const Dot = styled.span<IDotProps>`
  white-space: nowrap;

  &:before {
    content: " ";
    width: 1rem;
    height: 1rem;
    border-radius: 100%;
    display: inline-block;
    background: red;
    vertical-align: middle;
    margin-right: 0.3rem;
    
    background: ${({ color }) => color};
`;
